import React from 'react';
import { Skeleton } from '@innovationnorway/cl-react';

const OpportunityCardSkeleton = () => {
  return (
    <div className="board__card stack-medium">
      <div className="stack-medium">
        <div className="flex gap-x--2 gap-y--1">
          <Skeleton width="5rem" />
          <Skeleton width="5rem" />
          <Skeleton width="5rem" />
        </div>
        <Skeleton width="70%" height="1.25rem" />
        <div className="flex gap--1">
          <Skeleton width="8rem" />
          <Skeleton width="8rem" />
        </div>
      </div>
      <div className="display--flex align-items--center gap--2">
        <Skeleton width="1.25rem" height="1.25rem" />
        <Skeleton width="1.25rem" height="1.25rem" />
        <Skeleton width="1.25rem" height="1.25rem" />
      </div>
    </div>
  );
};

export default OpportunityCardSkeleton;
